/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sl_Lot_BackInputs */

const vi_sl_lot_back = /** @type {(inputs: Sl_Lot_BackInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quay lại`)
};

/**

* @param {Sl_Lot_BackInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const sl_lot_back = /** @type {((inputs?: Sl_Lot_BackInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sl_Lot_BackInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sl_lot_back(inputs)
});